<template>
  <el-dialog
    :title="activeItem.tenantId ? '部门权限' : '人员权限'"
    :visible.sync="$parent.powerDialogVisible"
    width="30%"
  >
    <div class="powerDialogWrap">
      <div class="rowBox">
        <h5>后台管理权限</h5>
        <el-switch
          v-model="websiteValue"
          :disabled="!activeItem.tenantId && !activeItem.department.hasManage"
        >
        </el-switch>
      </div>
      <div class="treeBox">
        <el-tree
          :data="websiteList"
          show-checkbox
          node-key="id"
          ref="tree"
          height="100%"
          highlight-current
          accordion
          :props="defaultProps"
          style="background: #f7f7f7"
        >
        </el-tree>
      </div>

      <div class="rowBox" v-if="!activeItem.tenantId">
        <h5>巨能管权限</h5>
      </div>
      <template v-if="!activeItem.tenantId">
        <el-radio-group v-model="appActive" style="margin-left: 30px">
          <el-radio :label="v.id" v-for="(v, i) in appAuthority" :key="i">{{
            v.title
          }}</el-radio>
        </el-radio-group>
      </template>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$parent.powerDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm" :loading="btnLoading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api";
export default {
  props: ["activeItem"],
  data() {
    return {
      btnLoading: false,
      defaultProps: {
        children: "children",
        label: "title",
      },
      websiteValue: false,
      websiteList: [],
      appActive: null,
      appAuthority: [
        { id: "admin", title: "管理员权限" },
        { id: "logistic", title: "后勤权限" },
      ],
    };
  },
  methods: {
    submitForm() {
      this.btnLoading = true;
      if (this.activeItem.tenantId) {
        this.submitDepartment();
      } else {
        this.submitUser();
      }
    },
    async submitDepartment() {
      let arr = this.$refs.tree.getCheckedNodes(false, true).map((i) => i.id);
      let res = await api.authorityEditDepartment({
        id: this.activeItem.id,
        hasManage: this.websiteValue,
        auth: arr.join(","),
      });
      if (res && res.data.code == 200) {
        this.update("tree");
      } else {
        this.btnLoading = false;
        this.$message.error(res.data.codeMsg);
      }
    },
    async submitUser() {
      let arr = this.$refs.tree.getCheckedNodes(false, true).map((i) => i.id);
      let res = await api.authoritySetUserAuth(
        {
          auth: arr.join(","),
          hasManage: this.websiteValue,
          appRole: this.appActive,
        },
        this.activeItem.user.id
      );
      if (res && res.data.code == 200) {
        this.update("user");
      } else {
        this.btnLoading = false;
        this.$message.error(res.data.codeMsg);
      }
    },
    update(type) {
      this.btnLoading = false;
      this.$message.success("修改成功");
      this.$parent.powerDialogVisible = false;
      this.$store.commit("SET_LOADING", true);
      setTimeout(() => {
        if (type == "tree") {
          this.$parent.updateTree();
        } else {
          this.$parent.updateUser();
        }
      }, 1000);
    },
    async getAuthorityTree() {
      this.websiteList = [];
      let res = await api.authorityGetAuthorityTree({
        departmentId: this.activeItem.tenantId
          ? this.activeItem.pid
          : this.activeItem.user.departmentId,
      });
      if (res && res.data.code == 200) {
        this.websiteList = res.data.data;
        this.setValue(
          this.activeItem.tenantId
            ? this.activeItem.auth
            : this.activeItem.user.auth
        );
      }
    },
    setValue(row) {
      this.$nextTick(() => {
        row.split(",").forEach((i) => {
          let node = this.$refs.tree.getNode(i);
          if (node && node.isLeaf) {
            this.$refs.tree.setChecked(node, true);
          }
        });
      });
    },
  },
  created() {
    // console.log(this.activeItem);
    if (this.activeItem.tenantId) {
      this.websiteValue = this.activeItem.hasManage;
    } else {
      this.websiteValue = this.activeItem.user.hasManage;
      this.appActive = this.activeItem.user.appRole;
    }
    this.getAuthorityTree();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.powerDialogWrap {
  height: 30vh;
  .treeBox {
    height: 70%;
    overflow: auto;
    background: #f7f7f7;
    border: 1px solid #e7e7e7;
    border-radius: 6px;
    margin-bottom: 10px;
  }
  .rowBox {
    @include setFlexStart;
    margin-bottom: 10px;
    h5 {
      font-size: 14px;
      margin-right: 20px;
    }
  }
}
</style>